import * as XLSX from "xlsx";

import { Button, Input, Loader } from "@mantine/core";
import {
  IconArrowLeft,
  IconLayoutGridFilled,
  IconPackage,
  IconSearch,
} from "@tabler/icons-react";
import { Modal, Table, Upload, notification } from "antd";
import { orpcClient } from "@/lib/orpc-client";
import { useEffect, useState } from "react";

import Papa from "papaparse";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface FileUploadItem {
  key: number;
  name: string;
  b: string;
  c: string;
  d: string;
  e: string;
  f: string;
  g: string;
  h: string;
  i: string;
  j: string;
  k: string;
  l: string;
  m: string;
  n: string;
  o: string;
  documentId?: string;
}

function AddSteelAssemblyBOM() {
  const { t } = useTranslation();
  const [fileUpload, setFileUpload] = useState<FileUploadItem[]>([]);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);

  const { id } = useParams();
  const navigate = useNavigate();

  const handlePageChange = (page: number, size?: number) => {
    setCurrentPage(page);
    if (size && size !== pageSize) {
      setPageSize(size);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [fileUpload]);

  const rowSelection = {
    fixed: "left" as const,
    onChange: (
      selectedRowKeys: React.Key[],
      selectedRows: FileUploadItem[],
    ) => {
      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        "selectedRows: ",
        selectedRows,
      );
    },
    getCheckboxProps: (record: FileUploadItem) => ({
      disabled: record.name === "Disabled User",
      name: record.name,
    }),
  };

  const handleChangePayableDetail = (
    documentId: string | number,
    value: string,
    type: string,
  ) => {
    setFileUpload((prev) => {
      const updatedList = prev.map((payable) => {
        if (payable.documentId === documentId || payable?.key === documentId) {
          return {
            ...payable,
            [type]: value,
          };
        }
        return payable;
      });

      return updatedList;
    });
  };

  const handleChangeFile = (
    info: any,
    setFileUpload: React.Dispatch<React.SetStateAction<FileUploadItem[]>>,
  ) => {
    const file = info.file.originFileObj;
    if (!file) return;

    const isExcel =
      file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      file.type === "application/vnd.ms-excel";
    const isCsv =
      file.type === "text/csv" || file.name.toLowerCase().endsWith(".csv");

    if (isExcel) {
      const reader = new FileReader();

      reader.onload = (e) => {
        if (!e.target?.result) return;
        const data = new Uint8Array(e.target.result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, {
          defval: "",
        }) as any[];

        const formattedData = processFileData(jsonData);
        setFileUpload(formattedData);
      };

      reader.readAsArrayBuffer(file);
    } else if (isCsv) {
      Papa.parse(file, {
        header: false,
        skipEmptyLines: true,
        complete: (results) => {
          const csvData = results.data.map((row: any) => {
            const obj: any = { 新建工程: row[0] || "" };
            row.forEach((cell: any, index: number) => {
              if (index === 0) return;
              if (index === 1) obj.__EMPTY = cell || "";
              else obj[`__EMPTY_${index - 1}`] = cell || "";
            });
            return obj;
          });
          const formattedData = processFileData(csvData);
          setFileUpload(formattedData);
        },
        error: (error) => {
          console.error("CSV parsing error:", error);
        },
      });
    } else {
      setFileUpload((prev) => [
        ...prev,
        {
          id: Date.now(),
          name: file.name,
        } as any,
      ]);
    }
  };

  const processFileData = (jsonData: any[]): FileUploadItem[] => {
    const filteredData = [];
    for (let i = 0; i < jsonData.length; i++) {
      const item = jsonData[i];
      const part = String(Object.values(item)[0]).trim();
      if (part === "SteelAssembly") {
        filteredData.push({
          ...item,
          nextRowEmpty2:
            i + 1 < jsonData.length ? jsonData[i + 1].__EMPTY_2 || "" : "",
        });
      }
    }

    return filteredData.map((item, index) => ({
      key: index,
      name: item?.新建工程 || "",
      b: item?.__EMPTY || "",
      c: item?.__EMPTY_1 || "",
      d: item?.__EMPTY_2 || "",
      e: item?.__EMPTY_3 || "",
      f: item?.__EMPTY_4 || "",
      g: item?.__EMPTY_5 || "",
      h: item?.__EMPTY_6 || "",
      i: item?.__EMPTY_7 || "",
      j: item?.__EMPTY_8 || "",
      k: item?.__EMPTY_9 || "",
      l: item?.__EMPTY_10 || "",
      m: item?.__EMPTY_11 || "",
      n: item?.__EMPTY_12 || "",
      o: item?.nextRowEmpty2 || "",
    }));
  };

  const columns = [
    // {
    //   title: '構件ID',
    //   dataIndex: 'name',

    //   render: (text, i) => {
    //     return (
    //       <Input
    //         placeholder="Input component"
    //         //leftSection={<IconMail size={16} />}
    //         value={i?.name}
    //         onChange={(e) =>
    //           handleChangePayableDetail(i?.documentId || i?.key, e.target.value, 'name')
    //         }
    //       />
    //     );
    //   },
    // },
    {
      title: "構件ID",
      dataIndex: "b",
      fixed: "left" as const,

      render: (text: any, i: FileUploadItem) => {
        return (
          <Input
            placeholder="Input component"
            leftSection={<IconPackage size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "b",
              )
            }
          />
        );
      },
    },
    {
      title: "構件編號",
      dataIndex: "c",

      render: (text: any, i: FileUploadItem) => {
        return (
          <Input
            placeholder="Input component"
            leftSection={<IconPackage size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "c",
              )
            }
          />
        );
      },
    },
    {
      title: "安裝位置",
      dataIndex: "d",
      render: (text: any, i: FileUploadItem) => {
        return (
          <Input
            placeholder="Input component"
            leftSection={<IconPackage size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "d",
              )
            }
          />
        );
      },
    },
    {
      title: "安裝高程",
      dataIndex: "e",
      render: (text: any, i: FileUploadItem) => {
        return (
          <Input
            placeholder="Input component"
            leftSection={<IconPackage size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "e",
              )
            }
          />
        );
      },
    },
    {
      title: "區別",
      dataIndex: "f",
      render: (text: any, i: FileUploadItem) => {
        return (
          <Input
            placeholder="Input component"
            leftSection={<IconPackage size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "f",
              )
            }
          />
        );
      },
    },
    {
      title: "拆運號碼",
      dataIndex: "g",
      render: (text: any, i: FileUploadItem) => {
        return (
          <Input
            placeholder="Input component"
            leftSection={<IconPackage size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "g",
              )
            }
          />
        );
      },
    },
    {
      title: "拆運說明",
      dataIndex: "h",
      render: (text: any, i: FileUploadItem) => {
        return (
          <Input
            placeholder="Input component"
            leftSection={<IconPackage size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "h",
              )
            }
          />
        );
      },
    },
    {
      title: "圖面名稱",
      dataIndex: "i",
      render: (text: any, i: FileUploadItem) => {
        return (
          <Input
            placeholder="Input component"
            leftSection={<IconPackage size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "i",
              )
            }
          />
        );
      },
    },
    {
      title: "總寬度",
      dataIndex: "j",
      render: (text: any, i: FileUploadItem) => {
        return (
          <Input
            placeholder="Input component"
            leftSection={<IconPackage size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "j",
              )
            }
          />
        );
      },
    },
    {
      title: "總高度",
      dataIndex: "k",
      render: (text: any, i: FileUploadItem) => {
        return (
          <Input
            placeholder="Input component"
            leftSection={<IconPackage size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "k",
              )
            }
          />
        );
      },
    },
    {
      title: "總長度",
      dataIndex: "l",
      render: (text: any, i: FileUploadItem) => {
        return (
          <Input
            placeholder="Input component"
            leftSection={<IconPackage size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "l",
              )
            }
          />
        );
      },
    },
    {
      title: "總重量",
      dataIndex: "m",
      render: (text: any, i: FileUploadItem) => {
        return (
          <Input
            placeholder="Input component"
            leftSection={<IconPackage size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "m",
              )
            }
          />
        );
      },
    },
    {
      title: "總面積",
      dataIndex: "n",
      render: (text: any, i: FileUploadItem) => {
        return (
          <Input
            placeholder="Input component"
            leftSection={<IconPackage size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "n",
              )
            }
          />
        );
      },
    },
    {
      title: "斷面規格",
      dataIndex: "o",
      render: (text: any, i: FileUploadItem) => {
        return (
          <Input
            placeholder="Input component"
            leftSection={<IconPackage size={16} />}
            value={text}
            onChange={(e) =>
              handleChangePayableDetail(
                i?.documentId || i?.key,
                e.target.value,
                "o",
              )
            }
          />
        );
      },
    },
    {
      title: "",
      fixed: "right",
      render: ({ key }: { key: React.Key }) => {
        return (
          <>
            <div>
              <Button
                variant="filled"
                color="gray"
                style={{ margin: "0.3rem" }}
                radius="md"
                // onClick={async () => {
                //   let result = await apiUserDeleteAccountsPayable({
                //     id: displayAccountPayable[key - 1]?.documentId,
                //   });
                //   fetchPayableData();
                // }}
              >
                編輯
              </Button>
            </div>
          </>
        );
      },
    },
  ];

  const handleUploadExcel = async (data: FileUploadItem[]) => {
    setIsUploading(true);
    const CHUNK_SIZE = 50;
    const allResults: any[] = [];

    try {
      for (let i = 0; i < data.length; i += CHUNK_SIZE) {
        const chunk = data.slice(i, i + CHUNK_SIZE);
        console.log(
          `Processing chunk ${Math.floor(i / CHUNK_SIZE) + 1}/${Math.ceil(data.length / CHUNK_SIZE)} (${chunk.length} items)`,
        );

        const batch = await orpcClient.materialBom.create(
          chunk.map((element) => ({
            projectId: id!,
            steelAssemblyId: element?.b ? String(element.b) : "",
            steelAssemblyCode: element?.c ? String(element.c) : "",
            installationLocation: element?.d || "",
            installationElevation: element?.e ? parseFloat(element.e) : null,
            distinction: element?.f ? String(element.f) : "",
            transportNumber: element?.g || "",
            transportDescription: element?.h || "",
            drawingName: element?.i || "",
            totalWidth: element?.j ? parseFloat(element.j) : null,
            totalHeight: element?.k ? parseFloat(element.k) : null,
            totalLength: element?.l ? parseFloat(element.l) : null,
            totalWeight: element?.m ? parseFloat(element.m) : null,
            totalArea: element?.n ? parseFloat(element.n) : null,
            metricSizeMark: element?.o || "",
          })),
        );
        const chunkResults = batch.map((res) =>
          res.success
            ? { status: "fulfilled" as const, value: res.data }
            : { status: "rejected" as const, reason: res.error },
        );

        allResults.push(...chunkResults);

        await new Promise((resolve) => setTimeout(resolve, 1000));
      }

      const failedResults = allResults.filter(
        (result) => result.status === "rejected",
      );
      const successCount = allResults.length - failedResults.length;

      setIsUploading(false);

      if (failedResults.length > 0) {
        console.error("Upload errors:", failedResults);
        api.error({
          message: `通知`,
          description: (
            <div>
              {t("steelAssemblyBOM.uploadPartialError", {
                failed: failedResults.length,
                success: successCount,
              })}
            </div>
          ),
          placement: "topLeft",
          duration: 0,
        });
      } else {
        api.success({
          message: `通知`,
          description: (
            <div>
              {t("steelAssemblyBOM.uploadSuccess", { count: successCount })}
            </div>
          ),
          placement: "topLeft",
          duration: 3,
        });
        navigate(`/hrMainPage/steelAssemblyBOM/${id}`);
      }
    } catch (e) {
      setIsUploading(false);
      console.error("Upload error:", e);
      api.error({
        message: `通知`,
        description: (
          <div>
            {(e as any)?.response?.data?.error?.message ||
              t("steelAssemblyBOM.uploadError")}
          </div>
        ),
        placement: "topLeft",
        duration: 0,
      });
    }
  };

  useEffect(() => {
    setIsUploadModalOpen(true);
  }, []);

  return (
    <div className="px-8 m-8">
      {contextHolder}
      {isUploading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(255,255,255,0.7)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Loader size="xl" color="blue" />
        </div>
      )}
      <div
        className="flex items-center justify-between px-4"
        style={{ backgroundColor: "#ECECEC", marginBottom: "1rem" }}
      >
        <div className="flex justify-start">
          <Button
            variant="filled"
            color="red"
            onClick={() => setFileUpload([])}
          >
            刪除Excel
          </Button>
        </div>
        <div className="flex items-center gap-3">
          <Button
            variant="outline"
            color="gray"
            leftSection={<IconArrowLeft size={16} />}
            onClick={() => navigate(`/hrMainPage/steelAssemblyBOM/${id}`)}
          >
            返回材料BOM
          </Button>
          <Button variant="default" onClick={() => setIsUploadModalOpen(true)}>
            匯入構件
          </Button>
          <Button
            variant="default"
            onClick={() => handleUploadExcel(fileUpload)}
          >
            儲存Excel
          </Button>
        </div>
      </div>

      <Table
        scroll={{ x: "max-content", y: 600 }}
        columns={columns}
        dataSource={fileUpload}
        pagination={{
          pageSize: pageSize,
          total: fileUpload.length,
          current: currentPage,
          onChange: handlePageChange,
          showSizeChanger: true,
          pageSizeOptions: ["20", "50", "100", "200"],
          showQuickJumper: true,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
        }}
        bordered
        sticky
      />

      <Modal
        title="匯入Excel或CSV檔案"
        open={isUploadModalOpen}
        onCancel={() => setIsUploadModalOpen(false)}
        footer={null}
        width={600}
      >
        <div className="flex flex-col items-center justify-center p-8">
          <Upload
            name="avatar"
            showUploadList={false}
            onChange={(info) => handleChangeFile(info, setFileUpload)}
            accept=".xlsx,.xls,.csv"
          >
            <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center cursor-pointer hover:border-blue-500 transition-colors">
              <div className="text-lg font-medium text-gray-700 mb-2">
                點擊或拖拽Excel或CSV檔案到此處
              </div>
              <div className="text-sm text-gray-500">
                支援 .xlsx、.xls 和 .csv 格式
              </div>
            </div>
          </Upload>

          {fileUpload.length > 0 && (
            <div className="mt-4 w-full">
              <div className="text-sm text-gray-600 mb-2">
                已載入 {fileUpload.length} 筆資料
              </div>
              <div className="flex gap-2">
                <Button
                  variant="default"
                  onClick={() => setIsUploadModalOpen(false)}
                >
                  關閉
                </Button>
                <Button
                  variant="filled"
                  color="blue"
                  onClick={() => {
                    handleUploadExcel(fileUpload);
                    setIsUploadModalOpen(false);
                  }}
                >
                  確認匯入
                </Button>
              </div>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
}

export default AddSteelAssemblyBOM;
